// Blitz is a plugin for caching pages. It caches Craft's CSRF token when
// enabled, making all forms submissions to fail. If the plugin is disabled
// no changes will be made and a JS error will be thrown in the console.

// Return a new CSRF token from Blitz or throw an error
const getBlitzCsrfToken = () => window.fetch('/actions/blitz/csrf/token')
  .then((res) => res.ok && res.text())
  .then((token) => token)
  .catch((err) => console.error(err));

// Update the CSRF field in all the forms using a new token
const refreshBlitzCsrfToken = (forms = [], tokenName = 'CRAFT_CSRF_TOKEN') => {
  [...forms].forEach(async (form) => {
    const field = form[tokenName];
    if (!field) return;
    const token = await getBlitzCsrfToken();
    token && field.setAttribute('value', token)
  });
};

export {
  getBlitzCsrfToken,
  refreshBlitzCsrfToken,
};
